import React, { useMemo, useState } from 'react';

import FiltersControls from 'common/FiltersControls/FiltersControls';
import { hasPermissionOrAdmin } from 'helpers/permissions';
import { VIEW_PERMISSIONS } from 'permissions/views';
import { useAppSelector } from 'store/hook';

import SalesBattlecardSaveFilterModal from './SalesBattlecardSaveFilterModal';
import { useCommunityViewContext } from '../View/CommunityViewContext';
import { DEFAULT_FILTERS } from '../View/constants';
import { equalFilters } from '../View/utils';

const SalesBattlecardFiltersControls = () => {
  const { view, viewFilters, setViewFilters } = useCommunityViewContext();
  const currentUser = useAppSelector((state) => state.auth.currentUser);
  const [openSaveModal, setOpenSaveModal] = useState(false);

  const filtersMatchSaved = useMemo(() => {
    return equalFilters(view?.filter, viewFilters);
  }, [view, viewFilters]);

  const handleReset = () => {
    setViewFilters({ ...DEFAULT_FILTERS });
  };

  const canEdit = hasPermissionOrAdmin(currentUser, [VIEW_PERMISSIONS.SALES_BATTLECARD.CHANGE]);

  return (
    <FiltersControls
      modal={<SalesBattlecardSaveFilterModal open={openSaveModal} onCancel={() => setOpenSaveModal(false)} />}
      showSaveFilter={canEdit}
      disableSaveFilter={filtersMatchSaved}
      onReset={handleReset}
      onSaveFilter={() => setOpenSaveModal(true)}
    />
  );
};

export default SalesBattlecardFiltersControls;
